import React from "react";
import Fade from "react-reveal/Fade";
export default function FadingScreen(props) {
  return (
    <>
      <Fade duration={2000}>
        <div style={{ backgroundColor: "black" }}>
          <div
            style={{
              opacity: window.pageYOffset > props.yPosition ? "0.5" : "1"
            }}
            className={props.subject}
          ></div>
        </div>
      </Fade>
    </>
  );
}
